module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Poem-title",
    attrs: {
      "id": "_idParaDest-3",
      "lang": "en-GB"
    }
  }, [_vm._v("W"), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("ith the Rising Sun")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("The sunlight begins to clear away the frost of the past months;")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Carrying the turning of seasons.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("The warm light clears away the shadows")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("And the fuzzy little creatures begin to awaken.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("The birds begin to chirp and sing in choirs joyfully.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Bright flowers grow and bloom,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Encouraged by the brilliance that is the sunlight.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("They bloom in colours of pink, yellow")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Blue, white and purple;")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Spreading their joy to those who glance at them.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("The bees come flying over and dance from colourful flower")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("To colourful flower,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Doing their jobs dutifully in uniforms of black and yellow.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Demeter cheers as her daughter Persephone creates")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("The spring in which the flowers bloom.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("People marble at the warmth of the season,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("And their moods lift as they spend")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("More time in the blessed outdoors; With their friends and family,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Living in the moment.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5993404","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781035801855_EPUB-7.vue
// module id = 78
// module chunks = 0